import { render } from "./MapPopupCard.vue?vue&type=template&id=81878892"
import script from "./MapPopupCard.vue?vue&type=script&lang=js"
export * from "./MapPopupCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__